import { setGlobalLoading } from '@/index';
import { sessionContext, useSessionContextValue } from './context';

export interface SessionProviderProps {
  children: ReactNode;
}

export function SessionProvider({ children }: SessionProviderProps) {
  const value = useSessionContextValue();
  useLayoutEffect(() => {
    setGlobalLoading(value.loading && 'percent');
  }, [value.loading]);
  return <sessionContext.Provider value={value}>{children}</sessionContext.Provider>;
}
